export enum CommonControllerMethods {
  GetWallets = 'getWallets',
}

export interface AuthorizationTokens {
  csrfToken?: string;
  customerToken?: string;
  walletToken?: string;
}
